import { sortDate } from "./sort"

const fileNameToDate = (fileName) => {
  const [year, month, day, hour, minute, second] = fileName.split('.')[0].split('-')
  return new Date(year, month - 1, day, hour, minute, second)
}

export const selectHeadingSections = (data) =>
  data.allHeadingSectionsJson.edges
    .map(({ node }) => ({
      title: node.title,
      bodyHtml: node.bodyHtml,
      imageData: node.image.childImageSharp?.gatsbyImageData,
      imagePublicURL: node.image.publicURL,
      createdAt: fileNameToDate(node.parent.name)
    }))
    .sort(sortDate('createdAt'))

const mapAnimal = (node) => ({
  id: node.id,
  name: node.name,
  bodyHtml: node.bodyHtml,
  bodyTruncatedHtml: node.bodyTruncatedHtml,
  bodyTruncated: node.bodyTruncated,
  imageData: node.image[0].childImageSharp?.gatsbyImageData,
  imagePublicURL: node.image[0].publicURL,
  images: node.image,
  category: node.category,
  gender: node.gender,
  years: node.years,
  months: node.months,
  weight: node.weight,
  path: node.gatsbyPath,
  type: node.type
})

export const selectAnimals = (data) =>
  data.allAnimalsJson.edges
    .map(({ node }) => mapAnimal(node));

export const selectAnimal = ({ animalsJson }) => mapAnimal(animalsJson)

const mapNews = (node) => ({
  title: node.title,
  bodyHtml: node.bodyHtml,
  bodyTruncatedHtml: node.bodyTruncatedHtml,
  bodyTruncated: node.bodyTruncated,
  imageData: node.image?.childImageSharp?.gatsbyImageData,
  imagePublicURL: node.image?.publicURL,
  createdAt: fileNameToDate(node.parent.name),
  path: node.gatsbyPath,
  cta: node.cta
})

export const selectNews = (data) =>
  data.allNewsJson.edges
    .map(({ node }) => mapNews(node))
    .sort(sortDate('createdAt', false))

export const selectNewsArticle = ({ newsJson }) => mapNews(newsJson)
